// HashtagCategoryList.jsx
import React, { useEffect, useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import HashtagCategoryItem from '../container/HashtagCategoryItem.js';
import { searchType } from '../resource/searchConstants.js';
import media from '../style/media.js';
import ArrowIconSrc from '../../img/ic-arrow-right-xs.svg';

export const HashtagCategoryList = ({
  t,
  meId,
  category,
  trendingHashtagFeed,
  shouldRefresh,
  hashtags,
  fetchTranslationByKey,
  fetchFeeds,
}) => {
  const fetchData = useCallback(
    ({ shouldSkipLocalCache } = {}) => {
      if (trendingHashtagFeed) {
        fetchTranslationByKey({
          groups: [trendingHashtagFeed],
        });
        fetchFeeds({
          type: trendingHashtagFeed,
          limit: 20,
          shouldSkipLocalCache,
        });
      }
    },
    [fetchFeeds, fetchTranslationByKey, trendingHashtagFeed]
  );

  useEffect(() => {
    fetchData();
  }, [fetchData, meId]);

  useEffect(() => {
    if (shouldRefresh) {
      fetchData({ shouldSkipLocalCache: shouldRefresh });
    }
  }, [fetchData, shouldRefresh]);

  if (!hashtags.length) return null;

  return (
    <StyledHashtagCategoryList>
      <HashtagItems>
        {hashtags.map((hashtag, index) => (
          <HashtagCategoryItem
            key={hashtag}
            hashtag={hashtag}
            index={index}
            category={category}
          />
        ))}
      </HashtagItems>
      <MoreButton to={`/search/${searchType.FLIX}`}>
        <MoreText>{t('more')}</MoreText>
        <img src={ArrowIconSrc} alt="more" width="16" height="16" />
      </MoreButton>
    </StyledHashtagCategoryList>
  );
};

HashtagCategoryList.propTypes = {
  t: PropTypes.func.isRequired,
  hashtags: PropTypes.array,
  meId: PropTypes.string,
  category: PropTypes.string,
  trendingHashtagFeed: PropTypes.string,
  shouldRefresh: PropTypes.bool,
  fetchTranslationByKey: PropTypes.func,
  fetchFeeds: PropTypes.func,
};

HashtagCategoryList.defaultProps = {
  hashtags: [],
  meId: null,
  category: '',
  trendingHashtagFeed: null,
  shouldRefresh: false,
  fetchTranslationByKey: () => null,
  fetchFeeds: () => null,
};

const StyledHashtagCategoryList = styled.div`
  display: flex;
  background-color: #191919;
`;

const HashtagItems = styled.div`
  padding-left: 16px;
  display: flex;
  flex-wrap: nowrap;

  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  ::-webkit-scrollbar {
    display: none;
  }
`;

const MoreButton = styled(Link)`
  padding-left: 12px;
  padding-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  opacity: 0.7;
  :hover {
    opacity: 0.5;
  }
  > img {
    width: 20px;
    height: 20px;
  }
`;

const MoreText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: rgba(255, 255, 255);
  white-space: nowrap;
  margin-right: 4px;
  ${media.tablet`
    font-size: 14px;
  `};
`;

export default withTranslation()(HashtagCategoryList);
